import React from 'react'
import { BrowserRouter as Router } from 'react-router'
import StartQuiz from '../StartQuiz'
import { TranslationProvider } from '../../shared/TranslationProvider'
import translations from '../locales.json'
import { QuizProvider, useQuiz } from '../QuizProvider'
import { WhatKindOfLeaderProvider } from './WhatKindOfLeaderProvider'
import Quiz from '../Quiz'
import Questions from './Questions'
import WhatKindOfLeaderResults from './WhatKindOfLeaderResults'
import { cn } from '~/lib/utils'

const WhatKindOfLeader = ({ locale, ...props }) => {
  return (
    <Router>
      <TranslationProvider
        locale={locale || 'en'}
        translations={translations}
        scope={'javascript.components.Quizzes'}
      >
        <QuizProvider {...props}>
          <WhatKindOfLeaderProvider>
            <WhatKindOfLeaderInner {...props} />
          </WhatKindOfLeaderProvider>
        </QuizProvider>
      </TranslationProvider>
    </Router>
  )
}

export default WhatKindOfLeader

const WhatKindOfLeaderInner = () => {
  const { documentId, started, showResults } = useQuiz()
  const startPage = !started && !showResults
  const quizClasses = cn(
    !startPage && 'quiz flex justify-center border-l border-[#DDD] px-4 py-6',
  )
  return (
    <div className={quizClasses}>
      {!started && !showResults && <StartQuiz quizExists={!!documentId} />}
      {started && !showResults && (
        <Quiz>
          <Questions />
        </Quiz>
      )}
      {showResults && <WhatKindOfLeaderResults />}
    </div>
  )
}
